import { render } from "./Discover.vue?vue&type=template&id=35a75aa9&scoped=true"
import script from "./Discover.vue?vue&type=script&lang=js"
export * from "./Discover.vue?vue&type=script&lang=js"

import "./Discover.vue?vue&type=style&index=0&id=35a75aa9&scoped=true&lang=css"

import exportComponent from "/var/www/mcd-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a75aa9"]])

export default __exports__